var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field has-addons" }, [
    _vm.readOnly
      ? _c("p", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.contactText,
                expression: "contactText",
              },
            ],
            staticClass: "input is-static",
            attrs: { readonly: "readonly", type: "text" },
            domProps: { value: _vm.contactText },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.contactText = $event.target.value
              },
            },
          }),
        ])
      : _c(
          "p",
          { staticClass: "control is-expanded" },
          [
            _vm.data
              ? _c(
                  "multiselect",
                  {
                    attrs: {
                      value: _vm.value,
                      "track-by": "key",
                      label: "value",
                      placeholder: "Select a contact",
                      options: _vm.data,
                      loading: _vm.isLoading,
                      "internal-search": false,
                      "options-limit": _vm.assetFilter.pageSize,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": true,
                    },
                    on: { input: _vm.change, "search-change": _vm.search },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.option.value))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2400269036
                    ),
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-danger",
                        attrs: { slot: "noResult" },
                        slot: "noResult",
                      },
                      [_vm._v("Contacts not found.")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
    !_vm.readOnly
      ? _c("p", { staticClass: "control" }, [
          _vm.contactId === ""
            ? _c(
                "a",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    "data-tooltip": "Add contact",
                    disabled: !_vm.editable,
                  },
                  on: { click: _vm.add },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm.contactId !== ""
            ? _c(
                "a",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Edit contact" },
                  on: { click: _vm.edit },
                },
                [_vm._m(1)]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }